// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Dp","card":"e_Ep","wideContainer":"e_Fp","containerHollow":"e_Gp"};